module.exports = __webpack_public_path__ + "static/media/refresh-boards-i-pad2x.73f65902.jpg";